import React, { Component } from 'react';
import './Tabbar.css';
import Tabs from './Tabs';

class Tabbar extends Component {
	render() {
		return (
			<Tabs activeTab={this.props.setActiveTab} />
		);
	}
}
export default Tabbar;


// WEBPACK FOOTER //
// ./src/Components/Tabbar/Tabbar.js